import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ArrowRight } from "../../../assets/arrow-right";
import styles from "./list-wrapper.module.css";
export var ListWrapper = function(param) {
    var children = param.children, heading = param.heading, urlText = param.urlText, href = param.href, isListCard = param.isListCard, handleTrackEvent = param.handleTrackEvent;
    var handleLinkTrackingEvent = function() {
        handleTrackEvent && handleTrackEvent();
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: !isListCard ? styles.heading : styles.listCardHeading,
                children: heading
            }),
            /*#__PURE__*/ _jsxs("ul", {
                className: styles.listWrapperContainer,
                children: [
                    children,
                    urlText && /*#__PURE__*/ _jsx("li", {
                        children: /*#__PURE__*/ _jsxs("a", {
                            className: !isListCard ? styles.wrapperLink : styles.listCardWrapperLink,
                            href: href,
                            onClick: handleLinkTrackingEvent,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: isListCard ? styles.listCardUrlText : "",
                                    children: urlText
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.wrapperLinkIcon,
                                    children: /*#__PURE__*/ _jsx(ArrowRight, {})
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
